import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { usePageSeo } from '../../utils/seo';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  content: string[];
  image: string;
  author: string;
  date: string;
  readTime: number;
  category: string;
  tags: string[];
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: 'Как правильно использовать промокоды: полное руководство',
    excerpt: 'Узнайте все секреты эффективного использования промокодов и купонов для максимальной экономии при онлайн-покупках.',
    content: [
      'Промокоды стали неотъемлемой частью онлайн-шопинга. Они позволяют экономить от 5% до 70% на покупках в интернет-магазинах. В этом руководстве мы расскажем, как правильно использовать промокоды и получать максимальную выгоду.',
      'Что такое промокод? Промокод — это специальная комбинация букв и цифр, которая дает право на скидку или бонус при покупке. Промокоды бывают публичными (доступны всем) и эксклюзивными (только для определенных пользователей).',
      'Где найти промокоды? Лучшие источники промокодов: специализированные сайты-агрегаторы, рассылки магазинов, социальные сети брендов, партнерские программы, кэшбэк-сервисы.',
      'Как применить промокод? Обычно в корзине или на странице оформления заказа есть поле "Промокод" или "Купон". Введите код, нажмите "Применить" и убедитесь, что скидка отобразилась в итоговой сумме.',
      'Важные правила: проверяйте срок действия промокода, читайте условия использования (минимальная сумма заказа, категории товаров), не все промокоды суммируются с другими акциями.',
      'Советы по экономии: подписывайтесь на рассылки любимых магазинов, используйте кэшбэк-сервисы вместе с промокодами, следите за сезонными распродажами, сохраняйте промокоды в закладках.'
    ],
    image: 'https://readdy.ai/api/search-image?query=person%20using%20smartphone%20for%20online%20shopping%20with%20discount%20coupons%20promotional%20codes%20on%20screen%20modern%20e-commerce%20savings%20concept&width=600&height=400&seq=promo-guide&orientation=landscape',
    author: 'Анна Смирнова',
    date: '2024-01-15',
    readTime: 5,
    category: 'Руководства',
    tags: ['промокоды', 'экономия', 'онлайн-шопинг']
  },
  {
    id: 2,
    title: 'Промокодные площадки: почему это выгодно для покупателей',
    excerpt: 'Разбираемся, какие преимущества дают промокодные сайты пользователям и как они помогают экономить тысячи рублей ежемесячно.',
    content: [
      'Промокодные площадки стали незаменимым инструментом для миллионов онлайн-покупателей. Эти сервисы собирают актуальные скидки и купоны от сотен магазинов в одном месте, экономя ваше время и деньги. Давайте разберемся, почему использование промокодных площадок — это разумное решение для каждого покупателя.',
      'Экономия времени — главное преимущество. Вместо того чтобы искать промокоды в поисковиках, проверять десятки сайтов и форумов, вы получаете доступ к проверенным кодам в одном месте. Промокодные площадки ежедневно обновляют базу, удаляют неработающие коды и добавляют новые акции. Это экономит часы вашего времени.',
      'Гарантия актуальности промокодов. Команды промокодных сервисов постоянно проверяют работоспособность кодов. Пользователи оставляют отзывы о том, сработал ли промокод, что помогает другим покупателям. На качественных площадках процент работающих промокодов достигает 80-90%, в то время как случайные коды из интернета работают лишь в 20-30% случаев.',
      'Доступ к эксклюзивным предложениям. Промокодные площадки сотрудничают напрямую с интернет-магазинами и получают эксклюзивные промокоды, которые недоступны обычным покупателям. Эти коды дают дополнительные 5-15% скидки сверх обычных акций магазина. Некоторые площадки предлагают уникальные условия: бесплатную доставку, подарки к заказу или повышенный кэшбэк.',
      'Удобная навигация и поиск. Промокоды организованы по категориям: магазины, товарные группы, размер скидки, срок действия. Вы можете быстро найти нужный код через поиск или отфильтровать предложения по интересующим параметрам. Многие площадки отправляют персональные подборки промокодов на основе ваших интересов.',
      'Уведомления о новых акциях. Подписавшись на рассылку или установив мобильное приложение, вы первыми узнаете о новых промокодах в любимых магазинах. Это особенно важно во время крупных распродаж, когда лучшие предложения разбирают за несколько часов. Push-уведомления помогут не упустить выгодную сделку.',
      'Обучающие материалы и советы. Качественные промокодные площадки публикуют статьи о том, как правильно экономить, когда лучше совершать покупки, как комбинировать разные способы экономии. Вы получаете не просто промокоды, а целую систему знаний о выгодном шопинге.',
      'Сообщество единомышленников. На промокодных площадках формируется сообщество покупателей, которые делятся находками, предупреждают о мошенниках, рекомендуют проверенные магазины. В комментариях можно найти полезные советы о том, как получить максимальную скидку или избежать подводных камней.',
      'Безопасность покупок. Промокодные площадки сотрудничают только с проверенными магазинами, что снижает риск мошенничества. Перед добавлением магазина в каталог проверяется его репутация, наличие юридической информации, отзывы покупателей. Это дополнительная гарантия безопасности ваших покупок.',
      'Реальная экономия. По статистике, пользователи промокодных площадок экономят в среднем 3 000-7 000 рублей ежемесячно. При крупных покупках (техника, мебель, путешествия) экономия может достигать 10 000-30 000 рублей. За год это превращается в значительную сумму, которую можно потратить на другие цели или отложить.',
      'Вывод: промокодные площадки — это не просто сайты со скидками, а полноценные сервисы, которые помогают покупателям экономить время, деньги и нервы. Использование таких площадок стало стандартом разумного потребления в эпоху онлайн-шопинга.'
    ],
    image: 'https://readdy.ai/api/search-image?query=happy%20people%20using%20laptop%20and%20smartphone%20browsing%20promo%20code%20website%20with%20discount%20coupons%20shopping%20online%20savings%20benefits%20modern%20digital%20lifestyle%20bright%20cheerful%20atmosphere&width=600&height=400&seq=promo-platforms-benefits&orientation=landscape',
    author: 'Сергей Морозов',
    date: '2024-01-18',
    readTime: 6,
    category: 'Руководства',
    tags: ['промокоды', 'площадки', 'выгода', 'экономия']
  },
  {
    id: 3,
    title: '10 лучших способов экономить на онлайн-покупках в 2024 году',
    excerpt: 'Откройте для себя проверенные стратегии экономии, которые помогут сократить расходы на покупки в интернете.',
    content: [
      'В 2024 году онлайн-шопинг стал еще доступнее благодаря множеству инструментов для экономии. Мы собрали 10 проверенных способов, которые помогут вам сократить расходы на покупки в интернете.',
      '1. Используйте промокоды и купоны. Перед каждой покупкой проверяйте наличие актуальных промокодов на специализированных сайтах. Это может сэкономить от 5% до 50% стоимости заказа.',
      '2. Подключите кэшбэк-сервисы. Возвращайте до 30% от стоимости покупок. Лучшие сервисы: Letyshops, Kopikot, Megabonus. Кэшбэк можно суммировать с промокодами.',
      '3. Сравнивайте цены. Используйте сервисы сравнения цен, чтобы найти самое выгодное предложение. Один и тот же товар может отличаться в цене на 20-40% в разных магазинах.',
      '4. Покупайте в сезонные распродажи. Черная пятница, Киберпонедельник, распродажи к праздникам — в эти периоды скидки достигают 70%.',
      '5. Подписывайтесь на рассылки. Магазины часто отправляют эксклюзивные промокоды подписчикам. Бонус за подписку может составлять 10-15% скидки на первый заказ.',
      '6. Используйте программы лояльности. Накапливайте баллы и обменивайте их на скидки. Некоторые программы дают до 10% кэшбэка баллами.',
      '7. Покупайте оптом. Многие магазины предлагают скидки при покупке нескольких единиц товара. Объединяйтесь с друзьями для совместных покупок.',
      '8. Следите за ценами. Установите уведомления о снижении цены на интересующие товары. Сервисы мониторинга цен помогут не упустить выгодное предложение.',
      '9. Используйте банковские карты с кэшбэком. Некоторые банки возвращают до 5% за покупки в определенных категориях.',
      '10. Покупайте в правильное время. Цены на технику падают перед выходом новых моделей, на одежду — в конце сезона, на путевки — за 2-3 месяца до поездки.'
    ],
    image: 'https://readdy.ai/api/search-image?query=money%20saving%20concept%20with%20calculator%20coins%20shopping%20cart%20discount%20tags%20financial%20planning%20for%20online%20purchases&width=600&height=400&seq=saving-tips&orientation=landscape',
    author: 'Михаил Петров',
    date: '2024-01-12',
    readTime: 7,
    category: 'Экономия',
    tags: ['экономия', 'советы', 'покупки']
  },
  {
    id: 4,
    title: 'Чёрная пятница 2024: как подготовиться к главной распродаже года',
    excerpt: 'Подробный план подготовки к Чёрной пятнице, чтобы получить максимальные скидки и не упустить лучшие предложения.',
    content: [
      'Чёрная пятница — самая масштабная распродажа года, когда скидки достигают 70-90%. Правильная подготовка поможет вам получить максимальную выгоду и не совершить импульсивных покупок.',
      'Когда проходит Чёрная пятница? В 2024 году Чёрная пятница выпадает на 29 ноября. Многие магазины начинают распродажи заранее — с середины ноября, а некоторые продлевают акции до Киберпонедельника (2 декабря).',
      'Шаг 1: Составьте список желаемых покупок. За месяц до распродажи определите, что именно вы хотите купить. Это поможет избежать спонтанных трат на ненужные вещи.',
      'Шаг 2: Мониторьте цены заранее. Начните отслеживать цены на интересующие товары за 2-3 недели до Чёрной пятницы. Некоторые магазины искусственно завышают цены перед распродажей.',
      'Шаг 3: Подпишитесь на рассылки. Магазины отправляют эксклюзивные промокоды и информацию о предстоящих акциях подписчикам. Подписывайтесь заранее, чтобы получить дополнительные скидки.',
      'Шаг 4: Зарегистрируйтесь в кэшбэк-сервисах. Во время Чёрной пятницы кэшбэк может увеличиваться до 20-30%. Это дополнительная экономия к скидкам магазина.',
      'Шаг 5: Подготовьте платежные средства. Убедитесь, что на карте достаточно средств, проверьте лимиты. Некоторые банки предлагают дополнительный кэшбэк в период распродаж.',
      'Шаг 6: Изучите условия возврата. Перед покупкой ознакомьтесь с политикой возврата товаров. Некоторые магазины ограничивают возврат товаров, купленных по акции.',
      'Что покупать на Чёрной пятнице? Максимальные скидки обычно на: электронику и гаджеты (до 50%), одежду и обувь (до 70%), товары для дома (до 60%), косметику и парфюмерию (до 50%).',
      'Чего избегать? Не покупайте товары только из-за скидки, проверяйте реальность скидок, читайте отзывы перед покупкой, не откладывайте покупку на последний момент — популярные товары быстро заканчиваются.'
    ],
    image: 'https://readdy.ai/api/search-image?query=black%20friday%20sale%20shopping%20bags%20discount%20tags%20promotional%20banners%20dark%20background%20with%20bright%20sale%20signs&width=600&height=400&seq=black-friday&orientation=landscape',
    author: 'Елена Козлова',
    date: '2024-01-10',
    readTime: 6,
    category: 'Распродажи',
    tags: ['чёрная пятница', 'распродажи', 'скидки']
  },
  {
    id: 5,
    title: 'Кэшбэк vs промокоды: что выгоднее для покупателя?',
    excerpt: 'Сравниваем два популярных способа экономии и выясняем, какой из них принесёт больше выгоды в разных ситуациях.',
    content: [
      'Кэшбэк и промокоды — два основных инструмента экономии при онлайн-покупках. Но что выгоднее? Давайте разберемся в преимуществах и недостатках каждого способа.',
      'Что такое промокод? Промокод дает мгновенную скидку при оформлении заказа. Вы вводите код, и цена сразу уменьшается на 5-50%. Скидка применяется до оплаты.',
      'Что такое кэшбэк? Кэшбэк — это возврат части потраченных денег после покупки. Обычно возвращается 1-30% от суммы заказа. Деньги поступают на счет через 1-3 месяца.',
      'Преимущества промокодов: мгновенная скидка, не нужно ждать возврата денег, часто дают большую скидку (до 50%), легко использовать.',
      'Недостатки промокодов: ограниченный срок действия, не всегда есть актуальные коды, могут не суммироваться с другими акциями, часто есть ограничения по минимальной сумме заказа.',
      'Преимущества кэшбэка: работает почти всегда, можно суммировать с промокодами и акциями, накапливается автоматически, дополнительные бонусы от банковских карт.',
      'Недостатки кэшбэка: нужно ждать возврата денег (1-3 месяца), процент возврата обычно небольшой (1-10%), нужно регистрироваться в сервисах, есть минимальная сумма для вывода.',
      'Что выгоднее? Для крупных покупок (от 10 000 руб.) — используйте промокод + кэшбэк одновременно. Для регулярных покупок — кэшбэк накапливается и дает стабильную экономию. Для срочных покупок — промокод дает мгновенную скидку.',
      'Лучшая стратегия: комбинируйте оба способа! Ищите промокод для мгновенной скидки, совершайте покупку через кэшбэк-сервис, используйте банковскую карту с кэшбэком. Так вы получите тройную выгоду!',
      'Пример расчета: покупка на 10 000 руб. Промокод 20% = скидка 2 000 руб. Кэшбэк 5% от 8 000 руб. = 400 руб. Банковский кэшбэк 2% = 160 руб. Итого экономия: 2 560 руб. (25,6%)!'
    ],
    image: 'https://readdy.ai/api/search-image?query=cashback%20versus%20promo%20codes%20comparison%20concept%20with%20money%20coins%20percentage%20symbols%20calculator%20modern%20financial%20illustration&width=600&height=400&seq=cashback-vs-promo&orientation=landscape',
    author: 'Дмитрий Волков',
    date: '2024-01-08',
    readTime: 4,
    category: 'Сравнения',
    tags: ['кэшбэк', 'промокоды', 'сравнение']
  },
  {
    id: 6,
    title: 'Мобильные приложения для поиска скидок: топ-5 лучших',
    excerpt: 'Обзор самых эффективных мобильных приложений, которые помогут найти лучшие скидки и промокоды.',
    content: [
      'Мобильные приложения для поиска скидок — незаменимые помощники современного покупателя. Мы протестировали десятки приложений и выбрали 5 лучших.',
      '1. Letyshops — лучший кэшбэк-сервис. Возврат до 30% от покупок в 2000+ магазинах. Удобное приложение с уведомлениями о повышенном кэшбэке. Быстрый вывод денег на карту или электронные кошельки. Бонус за регистрацию — 500 рублей.',
      '2. Едадил — промокоды и акции супермаркетов. Каталоги всех супермаркетов в одном приложении. Промокоды на доставку еды. Персональные скидки по карте лояльности. Уведомления о новых акциях в ближайших магазинах.',
      '3. Kupikupon — агрегатор промокодов. База из 50 000+ актуальных промокодов. Проверка промокодов перед использованием. Уведомления о новых кодах для избранных магазинов. Рейтинг промокодов от реальных пользователей.',
      '4. Kopikot — кэшбэк + промокоды. Возврат до 25% от покупок. Встроенный каталог промокодов. Дополнительные бонусы за активность. Партнерская программа с выгодными условиями.',
      '5. Megabonus — кэшбэк и сравнение цен. Возврат до 20% от покупок. Сравнение цен в разных магазинах. Уведомления о снижении цен. Календарь распродаж и акций.',
      'Как выбрать приложение? Для кэшбэка — Letyshops или Kopikot. Для промокодов — Kupikupon. Для продуктов — Едадил. Для сравнения цен — Megabonus.',
      'Советы по использованию: установите 2-3 приложения для разных целей, включите уведомления о новых акциях, проверяйте приложения перед каждой покупкой, используйте реферальные программы для дополнительных бонусов.',
      'Безопасность: все перечисленные приложения проверены и безопасны. Они не требуют данных банковских карт и не имеют доступа к вашим личным данным. Скачивайте приложения только из официальных магазинов App Store и Google Play.',
      'Экономия с приложениями: в среднем пользователи экономят 3 000-5 000 рублей в месяц, используя приложения для поиска скидок. При крупных покупках экономия может достигать 10 000-15 000 рублей!'
    ],
    image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20discount%20shopping%20apps%20on%20screen%20mobile%20interface%20showing%20deals%20coupons%20promotional%20offers%20modern%20technology&width=600&height=400&seq=mobile-apps&orientation=landscape',
    author: 'Ольга Иванова',
    date: '2024-01-05',
    readTime: 8,
    category: 'Приложения',
    tags: ['приложения', 'скидки', 'мобильные']
  },
  {
    id: 7,
    title: 'Психология скидок: почему мы покупаем больше во время распродаж',
    excerpt: 'Разбираем психологические механизмы, которые заставляют нас тратить больше денег во время акций и распродаж.',
    content: [
      'Распродажи и скидки — мощный маркетинговый инструмент, который заставляет нас покупать больше, чем планировали. Давайте разберемся, какие психологические механизмы за этим стоят.',
      'Эффект дефицита. "Только сегодня!", "Осталось 3 штуки!" — такие фразы создают ощущение срочности. Мы боимся упустить выгодное предложение и совершаем импульсивную покупку, даже если товар нам не очень нужен.',
      'Якорение цены. Когда мы видим зачеркнутую старую цену рядом с новой, мозг автоматически сравнивает их. Скидка 50% кажется невероятно выгодной, даже если изначальная цена была завышена.',
      'Эффект бесплатности. "Купи 2 — получи 3-й в подарок!" звучит заманчиво. Мы готовы купить больше, чем нужно, только чтобы получить "бесплатный" товар, хотя в итоге тратим больше денег.',
      'Социальное доказательство. "1000 человек уже купили этот товар!" — мы склонны доверять выбору других людей. Если многие покупают, значит, товар действительно хороший и выгодный.',
      'Эмоциональные покупки. Скидки вызывают выброс дофамина — гормона удовольствия. Мы получаем удовольствие не от самой покупки, а от ощущения выгодной сделки. Это может привести к шопоголизму.',
      'Ловушка минимальной суммы. "Бесплатная доставка от 2000 руб." — мы добавляем в корзину ненужные товары, чтобы достичь минимальной суммы. В итоге тратим больше, чем сэкономили на доставке.',
      'Как не попасться на уловки? Составляйте список покупок заранее и придерживайтесь его. Сравнивайте цены в разных магазинах. Подождите 24 часа перед покупкой — импульс пройдет. Рассчитайте реальную выгоду с учетом всех расходов.',
      'Когда скидки действительно выгодны? Если товар был в вашем списке желаний. Если вы сравнили цены и это действительно лучшее предложение. Если товар нужен прямо сейчас. Если скидка составляет минимум 30-40%.',
      'Вывод: скидки — это инструмент маркетинга, который играет на наших эмоциях и когнитивных искажениях. Осознанный подход к покупкам поможет экономить по-настоящему, а не тратить больше под видом экономии.'
    ],
    image: 'https://readdy.ai/api/search-image?query=psychology%20of%20shopping%20consumer%20behavior%20during%20sales%20brain%20with%20shopping%20symbols%20discount%20psychology%20concept%20illustration&width=600&height=400&seq=shopping-psychology&orientation=landscape',
    author: 'Александр Новиков',
    date: '2024-01-03',
    readTime: 6,
    category: 'Психология',
    tags: ['психология', 'покупки', 'поведение']
  }
];

const categories = ['Все', 'Руководства', 'Экономия', 'Распродажи', 'Сравнения', 'Приложения', 'Психология'];

export default function Blog() {
  const { id } = useParams();
  const [selectedCategory, setSelectedCategory] = useState('Все');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPost, setSelectedPost] = useState<BlogPost | null>(null);

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'Все' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         post.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handlePostClick = (post: BlogPost) => {
    setSelectedPost(post);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackToList = () => {
    setSelectedPost(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  usePageSeo({
    title: selectedPost ? `${selectedPost.title} | Promokod.online` : 'Блог о промокодах и экономии | Promokod.online',
    description: selectedPost?.excerpt ?? 'Полезные статьи о промокодах, скидках и способах экономии на онлайн-покупках. Советы, обзоры распродаж и практичные лайфхаки для выгодного шопинга.',
    canonicalPath: '/blog',
    ogType: selectedPost ? 'article' : 'website',
  });

  // Если выбрана статья, показываем полный текст
  if (selectedPost) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        {/* Article Header */}
        <article className="bg-white">
          <div className="max-w-4xl mx-auto px-4 py-12">
            <button
              onClick={handleBackToList}
              className="flex items-center gap-2 text-orange-600 hover:text-orange-700 mb-6 font-medium cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Вернуться к списку статей
            </button>

            <div className="mb-6">
              <span className="bg-orange-100 text-orange-600 text-sm px-3 py-1 rounded-full font-medium">
                {selectedPost.category}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {selectedPost.title}
            </h1>

            <div className="flex items-center gap-6 text-sm text-gray-600 mb-8 pb-8 border-b">
              <div className="flex items-center gap-2">
                <i className="ri-user-line"></i>
                <span>{selectedPost.author}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>{formatDate(selectedPost.date)}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>{selectedPost.readTime} мин чтения</span>
              </div>
            </div>

            <div className="mb-8 rounded-xl overflow-hidden">
              <img
                src={selectedPost.image}
                alt={selectedPost.title}
                className="w-full h-96 object-cover"
              />
            </div>

            <div className="prose prose-lg max-w-none">
              {selectedPost.content.map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed mb-6 text-lg">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="flex flex-wrap gap-2 mt-8 pt-8 border-t">
              {selectedPost.tags.map(tag => (
                <span key={tag} className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-full">
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="bg-gray-50 py-12">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Похожие статьи</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {blogPosts
                .filter(post => post.id !== selectedPost.id && post.category === selectedPost.category)
                .slice(0, 3)
                .map(post => (
                  <article
                    key={post.id}
                    onClick={() => handlePostClick(post)}
                    className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden cursor-pointer group"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-5">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-orange-600 transition-colors">
                        {post.title}
                      </h3>
                      <p className="text-gray-600 mb-6 text-lg">
                        {post.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-gray-500">
                        <span>{post.author}</span>
                        <span>{post.readTime} мин</span>
                      </div>
                    </div>
                  </article>
                ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  // Список статей
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Блог о промокодах и экономии
          </h1>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Полезные статьи, советы и руководства по эффективному использованию промокодов и экономии на покупках
          </p>
        </div>
      </section>

      {/* Search and Filters */}
      <section className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
            {/* Search */}
            <div className="relative flex-1 max-w-md">
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Поиск статей..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
              />
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Featured Article */}
      {filteredPosts.length > 0 && (
        <section className="py-12">
          <div className="max-w-6xl mx-auto px-4">
            <div
              onClick={() => handlePostClick(filteredPosts[0])}
              className="bg-white rounded-xl shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="lg:flex">
                <div className="lg:w-1/2">
                  <img
                    src={filteredPosts[0].image}
                    alt={filteredPosts[0].title}
                    className="w-full h-64 lg:h-full object-cover"
                  />
                </div>
                <div className="lg:w-1/2 p-8">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="bg-orange-100 text-orange-600 text-sm px-3 py-1 rounded-full font-medium">
                      Рекомендуем
                    </span>
                    <span className="text-gray-500 text-sm">{filteredPosts[0].category}</span>
                  </div>
                  <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                    {filteredPosts[0].title}
                  </h2>
                  <p className="text-gray-600 mb-6 text-lg">
                    {filteredPosts[0].excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4 text-sm text-gray-500">
                      <span>{filteredPosts[0].author}</span>
                      <span>{formatDate(filteredPosts[0].date)}</span>
                      <span>{filteredPosts[0].readTime} мин чтения</span>
                    </div>
                    <button className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium whitespace-nowrap">
                      Читать статью
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Articles Grid */}
      <section className="pb-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.slice(1).map(post => (
              <article
                key={post.id}
                onClick={() => handlePostClick(post)}
                className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden group cursor-pointer flex flex-col h-full"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/90 backdrop-blur-sm text-gray-700 text-xs px-2 py-1 rounded-full font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 line-clamp-2 group-hover:text-orange-600 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm line-clamp-3 flex-1">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between text-xs text-gray-500 mb-4">
                    <span>{post.author}</span>
                    <span>{formatDate(post.date)}</span>
                    <span>{post.readTime} мин</span>
                  </div>
                  
                  <div className="flex flex-wrap gap-1 mb-4">
                    {post.tags.map(tag => (
                      <span key={tag} className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  
                  <button className="w-full bg-orange-500 text-white py-3 px-4 rounded-lg hover:bg-orange-600 transition-colors font-medium whitespace-nowrap group-hover:bg-orange-600 mt-auto">
                    Читать полностью
                  </button>
                </div>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-article-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Статьи не найдены</h3>
              <p className="text-gray-600">Попробуйте изменить параметры поиска</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
